<template>
  <el-container>
    <el-row style="width:100%;">
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="現在のパスワード" prop="oldPassword" style="width:100%;">
          <el-input v-model="form.oldPassword" type="password" :suffix-icon="IconEyeSlash" autocomplete="old-password"
            :minlength="8" :maxlength="maxLength" ref="firstInput" v-if="!showOldPassword" />
          <el-input v-model="form.oldPassword" :suffix-icon="IconEye" autocomplete="old-password" :minlength="8"
            :maxlength="maxLength" ref="firstInput" v-if="showOldPassword" />
          <el-button class="btn-height" type="primary" @click="showOldPassword = !showOldPassword"
            style="position:absolute;left:380px;top:0px;opacity: 0;" />
        </el-form-item>
        <el-form-item label="変更後のパスワード" prop="newPassword1" style="padding-top:0.5em;">
          <el-input v-model="form.newPassword1" type="password" :suffix-icon="IconEyeSlash" autocomplete="new-password1"
            :minlength="8" :maxlength="maxLength" v-if="!showNewPassword1" />
          <el-input v-model="form.newPassword1" :suffix-icon="IconEye" autocomplete="new-password1" :minlength="8"
            :maxlength="maxLength" v-if="showNewPassword1" />
          <el-button class="btn-height" type="primary" @click="showNewPassword1 = !showNewPassword1"
            style="position:absolute;left:380px;top:0px;opacity: 0;" />
        </el-form-item>
        <el-form-item label="変更後のパスワード（確認）" prop="newPassword2" style="padding-top:0.5em;">
          <el-input v-model="form.newPassword2" type="password" :suffix-icon="IconEyeSlash" autocomplete="new-password2"
            :minlength="8" :maxlength="maxLength" v-if="!showNewPassword2" />
          <el-input v-model="form.newPassword2" :suffix-icon="IconEye" autocomplete="new-password2" :minlength="8"
            :maxlength="maxLength" v-if="showNewPassword2" />
          <el-button class="btn-height" type="primary" @click="showNewPassword2 = !showNewPassword2"
            style="position:absolute;left:380px;top:0px;opacity: 0;" />
        </el-form-item>

        <el-row>
          <p style="text-align:center">[パスワードポリシー]<br>
            ・パスワードは8文字以上入力してください。<br>
            ・数字、英大文字、英小文字を1文字以上含めてください。<br>
            ・以下の特殊文字のいずれか1文字以上を含めてください。<br>
            特殊文字： ^$*.[]{}()?-&quot;!@#%&amp;/\,&gt;&lt;&#39;:;|_~`+=</p>
        </el-row>
        <el-row>
          <p v-if="message" style="color: #F56C6C;">{{ message }}</p>
        </el-row>
        <el-row :gutter="20" style="justify-content:center;margin-top:16%;">
          <el-button class="button-style" color="#ffdf5e" type="primary" @click="clickChangePassword">
            変更
          </el-button>
        </el-row>
      </el-form>
    </el-row>
  </el-container>
</template>

<script>
import { ElMessage } from 'element-plus'
import { CognitoUserAccessor } from "@/views/js/cognito-login"
import { signout } from "../views/js/cognito";
import ConstParam from '../views/js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'

export default {
  // emits: ['closeDialog'],
  mounted() {
    this.$refs.firstInput.focus()
  },
  data() {
    return {
      showOldPassword: false,
      showNewPassword1: false,
      showNewPassword2: false,
      IconEye: shallowRef(icons.IconEye),
      IconEyeSlash: shallowRef(icons.IconEyeSlash),
      maxLength: ConstParam.maxLength,
      dialogVisible: false,
      message: '',
      form: {
        oldPassword: '',
        newPassword1: '',
        newPassword2: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: 'この項目は入力が必須です。' },
        ],
        newPassword1: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ],
        newPassword2: [
          { required: true, message: 'この項目は入力が必須です。' },
          { min: 8, message: '8文字以上で入力してください。' },
          { max: this.maxLength, message: this.maxLength + '文字以下で入力してください。' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S+$/, message: '大文字・小文字・数字、特殊文字をそれぞれ１文字以上含む必要があります。' },
        ],
      }
    }
  },
  methods: {
    passwordMessage(message) {
      this.$alert(message, "", {
        confirmButtonText: 'もう一度実行'
      }).catch(() => {
        return
      });
    },
    async clickChangePassword() {
      this.message = "";
      if (this.form.newPassword1 !== this.form.newPassword2) {
        this.message = '変更後のパスワードと変更後のパスワード（確認）が一致しません。'
        return
      }
      const re = new RegExp(ConstParam.password_reg)
      if (!re.test(this.form.newPassword1)) {
        this.passwordMessage(ConstParam.password_error)
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.message = '赤枠表示部分の入力内容を修正してください。'
          return
        }
        CognitoUserAccessor.changePassword(this.form.oldPassword, this.form.newPassword1)
          .then(() => {
            this.dialogVisible = false
            this.viewMessage('パスワードを変更しました。', 'success')
            this.message = ''
            this.$refs.formRef.resetFields()
            this.$store.commit('setCowMenuSelect', '');
            this.signOut();
            this.$router.push('/login')
          })
          .catch(error => {
            this.viewMessage('パスワード変更に失敗しました。(' + error.message + ')', 'error')
          })
      })
    },
    async signOut() {
      await signout();
    },
    viewMessage(message, status) {
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-input {
  width: 412px;
  height: 50px;
}

.btn-height {
  height: 50px;
}

.btn-width {
  width: 412px;
}

#login_button {
  color: #383838;
  background: #ffdf5e;
}
</style>